<div class="absolute" *ngIf="!load && savInfo">
  <div class="flex items-center">
    <img src="assets/pictogrammes/telephone.svg" class="img-invert" width="60px">
    <span *ngIf="savInfo.phone_work">{{ savInfo.phone_work | FormatPhone }}</span>
  </div>
</div>
<h1 class="center">Contacter votre interlocuteur dédié</h1>
<form [formGroup]="contactForm" class="flex justify-center" (ngSubmit)="submitForm()">
  <mat-card>
    <mat-form-field>
      <mat-label>Type de demande</mat-label>
      <mat-select placeholder="Sélectionner le type de demande" formControlName="type">
        <mat-option value="Réclamation">{{reclamation}}</mat-option>
        <mat-option value="Autre demande">{{autre}}</mat-option>
      </mat-select>
      <mat-error *ngIf="contactForm.get('type').hasError('required')">Il faut renseigner un type de
        demande</mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="contactForm.value.type && contactForm.value.type == reclamation">
      <mat-label>Motif</mat-label>
      <mat-select placeholder="Sélectionner le motif" formControlName="motif">
        <mat-option *ngFor="let motif of motifs" [value]="motif.id">
          {{motif.libelle}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="contactForm.get('motif').hasError('required')">Il faut renseigner un motif</mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="contactForm.value.type && contactForm.value.type == autre">
      <mat-label>Motif (max. 100 caractères)</mat-label>
      <input matInput formControlName="motif" placeholder="Saisir un motif" />
      <mat-error
        *ngIf="contactForm.get('motif').hasError('required') || contactForm.get('motif').hasError('maxlength')">Il faut
        renseigner un motif (max. 100 caractères)</mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="contactForm.value.type && contactForm.value.type == reclamation">
      <mat-label>Description (min. 150 caractères)</mat-label>
      <textarea matInput rows="10" cols="10" placeholder="Saisir une description"
        formControlName="description"></textarea>
      <mat-error
        *ngIf="contactForm.get('description').hasError('required') || contactForm.get('description').hasError('minlength')">Il
        faut renseigner une description (min. 150 caractères)</mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="contactForm.value.type && contactForm.value.type == autre">
      <mat-label>Description (min. 50 caractères)</mat-label>
      <textarea matInput rows="10" cols="10" placeholder="Saisir une description"
        formControlName="description"></textarea>
      <mat-error
        *ngIf="contactForm.get('description').hasError('required') || contactForm.get('description').hasError('minlength')">Il
        faut renseigner une description (min. 50 caractères)</mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="contactForm.value.type">
      <input matInput disabled placeholder="Pièces jointes (tous formats | max. 3 fichiers | max. 10Mo)"
        value="Choisir un ou des fichiers à rajouter">
      <input hidden (change)="onFileSelected()" #fileInput name="uploadfile" type="file" id="file" multiple>
      <button mat-icon-button matSuffix type='button' (click)="fileInput.click()" [disabled]="files.length > 2">
        <mat-icon>attach_file</mat-icon>
      </button>
    </mat-form-field>
    <div *ngFor="let element of files" class="flex items-center">
      <div class="file-selected-name"><b>{{element.name}}</b></div>
      <button mat-icon-button type='button' (click)="deleteFile(element)">
        <mat-icon color="red">close</mat-icon>
      </button>
    </div>
    <mat-card-actions>
      <button mat-raised-button color="primary" type="submit" [disabled]="!contactForm.valid || sendingForm">
        <mat-spinner diameter="20" *ngIf="sendingForm"></mat-spinner>Envoyer
      </button>
    </mat-card-actions>
  </mat-card>
</form>